export default __webpack_public_path__ + "static/media/impact_transparent.ca8eda88.webp";